import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import './ContactUs.css';

function ContactUs() {
    return (
      <section
      className="w-full bg-[#0F0F0F] px-4 py-20 flex justify-center items-center"
      style={{ minHeight: "100vh" }}
    >
      <div
        className="container py-5 text-center"
        style={{ 
        maxWidth : "1102px",  display: "flex", flexDirection : "column", alignItems : "center", gap : "40px", alignSelf : "stretch", borderRadius: "20px",
          border: "conic-gradient(from 90deg, #D8D8D8, #1E1E1E, #D8D8D8)"}}
      >
          
       
          <section className="contact-section fade-in-up">
      <div className="contact-container">
        <div className="contact-text">
          <h2 style={{ fontSize: "50px", fontWeight: "700", marginBottom: "20px", fontFeatureSettings: "'dlig' on", textAlign: "left" }}>
            Contact Us
          </h2>
          <p style={{ fontSize: "16px", lineHeight: "24px", fontWeight: "400", fontFeatureSettings: "'dlig' on", textAlign: "left" }}>
            Got bank or brand points? <br />
            Turn them into <strong style={{ fontWeight: "700" }}>instant cash</strong> you can spend today!
          </p>
        </div>
        <div className="contact-image" />
      </div>
    </section>
    <style>
  {`
    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(30px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .fade-in-up {
      animation: fadeInUp 1s ease-out forwards;
      animation-delay: 0.3s;
      opacity: 0;
    }
  `}
</style>

    <div  className="fade-in-up" style={{
      textAlign: "center",
      padding: "20px",
      fontSize: "24px",
      fontWeight: "400"
    }}>
      Exchange your bank, brand, and e-commerce loyalty points for real currency,<br />
      available for immediate spending.
    </div>
    <style>
  {`
    @keyframes fadeInUp {
      0% {
        opacity: 0;
        transform: translateY(30px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .fade-in-up {
      animation: fadeInUp 1s ease-out forwards;
      animation-delay: 0.3s;
      opacity: 0;
    }
  `}
</style>

<section
  style={{
    display: "flex",
    width: "1070px",
    height: "854px",
    justifyContent: "center",
    alignItems: "center",
    border: "0.1px solid #D8D8D8", 
    borderRadius: "20px" 
  }}
>
  <div style={{ width: "100%" }}> 
        <h2 className="text-center text-lg  " style={{fontWeight : "700", fontSize : "30.212px", paddingTop : "40px"}}>Be a Part of Briospark</h2>
      
        <hr 
  style={{ 
    width: "752.77px",
    height: "2px",
    border: "none",
    background: "linear-gradient(to right, #07A5DF, #3417B7)",
    marginBottom: "65px",
    marginLeft : "160px",
    borderRadius: "2px"
  }} 
/>

        <form className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12  gap-y-8" style={{ justifyContent: "space-between", marginBottom: "25.18px"  }}>
    <input
      type="text"
      placeholder="First Name"
      className="first-name bg-[#0F0F0F] text-white flex items-center"
      style={{
        placeholder: "white",
        paddingTop: "19.3px",
        paddingBottom: "21.08px",
        paddingRight : "20px",
        borderRadius: "16.784px",
        minWidth: "365px",
        marginRight : "22.69px",
        backgroundColor: "#121417",
        border: "linear-gradient(135deg, #D8D8D8, #1E1E1E, #D8D8D8)"

      }}
    />
  
    <input
      type="text"
      placeholder="Last Name"
      className="last-name bg-[#0F0F0F] text-white flex items-center"
      style={{
        placeholder: "white",
        paddingTop: "19.3px",
        paddingBottom: "21.08px",
        borderRadius: "16.784px",
        minWidth: "365px",
        backgroundColor: "#121417",
        border: "linear-gradient(135deg, #D8D8D8, #1E1E1E, #D8D8D8)"
      }}
    />
  </div>
  
    
       
          <div className="grid grid-cols-1 md:grid-cols-2" style={{marginBottom : "25.18px" }}>
            <input
              type="text"
              placeholder="Phone Number"
              className="phone bg-[#0F0F0F] text-white  flex items-center"
              style={{  placeholder: "white", marginRight: "22.66px", paddingTop: "19.3px", paddingBottom: "21.08px", borderRadius : "16.784px" , minWidth : "365px", backgroundColor : "#121417", border : "linear-gradient(135deg, #D8D8D8, #1E1E1E, #D8D8D8)"}}
            />
            <input
              type="email"
              placeholder="E-Mail"
              className="email bg-[#0F0F0F] text-white  flex items-center"
              style={{  placeholder: "white", paddingTop: "19.3px", paddingBottom: "21.08px", borderRadius : "16.784px" , minWidth : "365px", backgroundColor : "#121417", border : "linear-gradient(135deg, #D8D8D8, #1E1E1E, #D8D8D8)"}}
            />
          </div>
    
    
          <div className="grid" >
          <input
            type="text"
            placeholder="Subject"
            className=" text-white  w-full"
            style={{ placeholder: "white", marginBottom : "25.18px",paddingTop: "19.3px", paddingBottom: "21.08px", borderRadius : "16.8px" , minWidth : "752px",minHeight: "55.388px", backgroundColor : "#121417", border : "linear-gradient(135deg, #D8D8D8, #1E1E1E, #D8D8D8)"}}
            
  
          />
          </div>
          <div className="grid" >
          <input 
            type="text"
            placeholder="Tell us something..."
            className=" text-white w-full"
            style={{ placeholder: "white", paddingTop: "19.3px", paddingBottom: "21.08px", borderRadius : "20px" , minWidth : "752px",minHeight : "252px", backgroundColor : "#121417", border : "conic-gradient(from 270deg, #D8D8D8, #1E1E1E, #D8D8D8)", padding: "padding: 19.302px 691.992px 21.086px 16.785px"}}
            
  
          />
          </div>
          
          <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px 0"
  }}
>
  <button
    style={{
      height: "48px",
    
      minWidth: "84px",
      maxWidth: "480px",
      padding: "10px 20px",
      borderRadius: "20px",
      background: "linear-gradient(270deg, #2563eb, #1d4ed8)",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      boxShadow: "2px 2px 3px 0px rgba(0, 0, 0, 0.3)",
      border: "none",
      cursor: "pointer"
    }}
  >
    Let’s Solve It Together
  </button>
</div>

        </form>
        </div>
        </section>
      </div>
      
      <style>{`
       input::placeholder,
    textarea::placeholder {
      color: white;
      font-weight: 400;
    }
    `}</style>
    </section>
    
    
    );
  }

  export default ContactUs;